import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import ResumeBox from "@/common/components/ResumeBox";
import useMaintenanceObjectiveSystem from "../../hooks/useMaintenanceObjectiveSystem";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronsRightIcon } from "lucide-react";

const MaintenanceObjectiveSystemsShow = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const {
    data: objectiveSystem,
    isPending: isObjectiveSystemPending,
    refetch: refetchObjectiveSystem,
    error: objectiveSystemError = {} as any,
  } = useMaintenanceObjectiveSystem(id);

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-64px)]"
      statusCode={objectiveSystemError?.status}
      refetchFunction={refetchObjectiveSystem}
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{ fallback: `/objective-maintenance/systems` }}
          titleClassName="text-nowrap max-w-56 overflow-hidden text-ellipsis font-normal text-base"
          title="Objetos de manutenção"
          subtitle={(
            <div className="flex items-center gap-2">
              <h2 className="text-white-400">
                Sistema
              </h2>

              <ChevronsRightIcon className="text-white-400" />

              <h2 className="text-white-800">
                {objectiveSystem?.display_name}
              </h2>
            </div>
          )}
          isLoading={isObjectiveSystemPending}
          buttons={(
            <div className="flex items-center gap-3">
              <Button
                name="update"
                operationKlassToCheckPermission="Admin::Maintenance::ObjectiveSystems::Update"
                onClick={() => navigate('edit')}
              >
                Editar
              </Button>
            </div>
          )}
        />

        <Box className="max-h-[calc(100vh-132px)] overflow-y-auto flex flex-col gap-4">
          <p className="text-lg font-medium">
            Dados gerais do sistema
          </p>

          <ResumeBox
            label="Nome do sistema"
            value={objectiveSystem?.display_name}
            isLoading={isObjectiveSystemPending}
            testId="display_name"
          />
        </Box>
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceObjectiveSystemsShow;
